<template>
  <div class="item-box-content" style="min-height:702px;padding:0;margin-bottom:0;">
    <div style="padding:20px 20px 0">
      <div class="title-font-style">
        <span>合同管理</span>
      </div>
    </div>
    <div style="padding:0 50px">
      <no-data
        v-show="params.state===1"
        :nodata="`nodataPurchase`"
        class="maintain-scheme"
        style="line-height:84px"
      >合同未生成，请根据需求选择是否生成退货合同</no-data>
      <div v-show="params.state!==1">
        <el-row style="margin:30px 0">
          <el-col :span="12">合同编号：{{queryParams.returnContractNumber}}</el-col>
          <el-col :span="12">发起时间：{{queryParams.createDate|dateFilter}}</el-col>
        </el-row>
        <el-steps :active="active" align-center class="mainStep">
          <el-step
            :title="item"
            v-for="(item, i) in stepList"
            :key="i"
            :icon="item==='审批不通过'?'':'el-icon-success'"
            :status="item==='审批不通过'?'error':''"
          ></el-step>
        </el-steps>
        <div
          class="maintain-scheme"
          v-show="queryParams.contractState===3||queryParams.contractState===5"
        >
          <div v-show="queryParams.contractState===3">
            <div>
              <i
                class="iconfont icon-xiaoshou-tuihuo-denghou"
                style="color:#60C96D;font-size:42px;"
              ></i>
            </div>
            <div class="title">请等待上级审批！</div>
          </div>
          <div v-show="queryParams.contractState===5">
            <div class="el-icon-error" style="color:#D35E5E;font-size:42px"></div>
            <div class="title">审批不通过！</div>
            <div class="text">备注：{{queryParams.mark}}</div>
          </div>
        </div>
      </div>
      <div style="margin-top:24px" v-show="queryParams.contractState!==3||params.state===1">
        <el-button type="primary" @click="onCreateContract" v-if="params.state===1">生成退货合同</el-button>
        <el-button
          type="primary"
          @click="onContractDownload"
          v-if="queryParams.contractState===1||queryParams.contractState===5"
        >下载退货合同</el-button>
        <el-button
          type="primary"
          @click="onSealedContract"
          v-if="queryParams.contractState===4"
        >下载已盖章合同</el-button>
        <el-button
          @click="onContractUpload"
          v-show="queryParams.contractState===1||queryParams.contractState===5"
        >上传盖章合同</el-button>
        <el-button @click="onCancellation" v-show="params.state!==1">合同作废</el-button>
      </div>
      <div
        class="config-instruction"
        style="padding: 14px 0 0"
        v-show="queryParams.contractState===4"
      >
        <i class="el-icon-warning-outline"></i>
        <span>说明：合同作废后可重新生成。</span>
      </div>
    </div>
    <!------------ 合同盖章上传 ------------>
    <sealed-contract-upload ref="sealedContractUploadRefs" v-show="isShow"></sealed-contract-upload>
  </div>
</template>

<script>
import { uploadDown } from '@/util/tool'
import sealedContractUpload from '../contractList/sealedContractUpload' // 合同盖章上传
import noData from '@/components/module/noData'
import {
  queryDefaultContract,
  queryDefaultContractAdd,
  updateContractSell,
  queryUploadOscId,
  queryUploadOscIdSeal
} from '@/api/sell/sellManage'
export default {
  components: {
    noData,
    'sealed-contract-upload': sealedContractUpload // 合同盖章上传
  },
  data() {
    return {
      isShow: false,
      active: 0,
      queryParams: {},
      params: {},
      stepList: ['合同生成', '待签署', '上传盖章合同', '合同审批', '审批通过']
    }
  },
  methods: {
    getList() {
      this.isShow = false
      queryDefaultContract(this.$route.query.id).then((res) => {
        if (res.data.code === 200) {
          this.params = res.data.obj
          this.queryParams = res.data.obj.orderSalereturnContract || {}
          if (+this.$route.query.stamp === 1) {
            this.onContractUpload()
          }
          this.stepList[4] =
            this.queryParams.contractState === 5 ? '审批不通过' : '审批通过'
          this.active =
            this.queryParams.contractState > 4
              ? 5
              : this.queryParams.contractState + 1
        }
      })
    },
    onCreateContract() {
      queryDefaultContractAdd(this.params).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('退货合同生成成功！')
          this.getList()
        }
      })
    },
    // 合同盖章上传
    onContractUpload() {
      this.isShow = true
      this.$refs.sealedContractUploadRefs.getList(this.queryParams.id, 4)
    },
    onContractDownload() {
      queryUploadOscId(this.queryParams.id).then((res) => {
        if (res.data.code === 200) {
          uploadDown(
            this.$store.state.https + res.data.obj.fileUrl,
            this.queryParams.returnContractNumber
          )
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onSealedContract() {
      queryUploadOscIdSeal(this.queryParams.id).then((res) => {
        if (res.data.code === 200) {
          uploadDown(
            this.$store.state.https + res.data.obj.fileUrl,
            this.queryParams.returnContractNumber
          )
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onCancellation() {
      updateContractSell(this.queryParams.id).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('合同作废成功！')
          this.getList()
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.maintain-scheme {
  padding: 30px;
  background: #f3f7ff;
  border-radius: 4px;
  text-align: center;
  margin-top: 20px;
  .title {
    margin: 0 auto;
    font-size: 18px;
    font-weight: 500;
    color: #4e555b;
    line-height: 32px;
  }
  .text {
    font-weight: 400;
    color: #83878a;
    line-height: 20px;
  }
}
</style>
